import axios from 'axios';
const CONTROLLER_PATH = 'Billing';
class BillingService {
    //CREATE
    create(entity) {
        return axios.post(CONTROLLER_PATH, entity).then((response) => response.data);
    }

    //READ
    get(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + (id ? '/' + id : ''), {params: urlParameters, requestId: requestId}).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }
    setConvertToAccount(id) {
        return axios.get(CONTROLLER_PATH + '/setConvertToAccount/'+id);
    }
    devgetclinicalnotes(id) {
        return axios.get(CONTROLLER_PATH + '/devgetclinicalnotes/'+id).then((response) => response.data);
    }    
    getbillingwidgetdto(urlParameters) {
        return axios.get(CONTROLLER_PATH + '/getbillingwidgetdto', {params: urlParameters}).then((response) => response.data);
    }  
    //UPDATE
    update(entity) {
        return axios.put(CONTROLLER_PATH + '/' + entity.id, entity).then((response) => response.data);
    }

    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + '/' + id).then(() => {});
    }
}

export default new BillingService();
